import angular from 'angular'
import fnPackageCtrl from './list'
import editFnPackageCtrl from './edit'
import listPage from './view/list.html'
import editPage from './view/edit.html'

function configRouter($stateProvider) {
    $stateProvider.state(
        'system.syssetting.fnPackage',
        {
            url: '/fnPackage',
            abstract: true,
            template: '<div ui-view></div>',
            default: 'system.syssetting.fnPackage.list',
            title: '功能包',
        },
    )
    $stateProvider.state(
        'system.syssetting.fnPackage.list',
        {
            url: '/list',
            template: listPage,
            controller: 'fnPackageCtrl',
        },
    )
    $stateProvider.state(
        'system.syssetting.fnPackage.edit',
        {
            url: '/edit/:packId',
            template: editPage,
            controller: 'editFnPackageCtrl',
            title: '编辑',
        },
    )
    $stateProvider.state(
        'system.syssetting.fnPackage.add',
        {
            url: '/add',
            template: editPage,
            controller: 'editFnPackageCtrl',
            title: '新增',
        },
    )
}

export default angular
    .module('system.syssetting.fnPackage', [])
    .config(['$stateProvider', configRouter])
    .controller('fnPackageCtrl', fnPackageCtrl)
    .controller('editFnPackageCtrl', editFnPackageCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/system/systemsetting/fnPackage/index.js